module.exports = __webpack_public_path__ + "static/media/599.756(37).57343e4a.pdf";